import setupAxios from './Base'
const prefix = '/_api_'

const axios = setupAxios()

export default class Legacy {
  constructor(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token.token}`
  }

  clearWedsiteCache(wed) {
    return axios.get(`${prefix}/clearWedsiteCache?wed=${wed}`)
  }
}
